<template>
    <v-card max-width="700" min-width="400">
        <v-list-item three-line>
            <v-list-item-content>
                <v-card-title>{{ "Active redirect banks" | t }}</v-card-title>
                <v-card-subtitle
                    >{{ "Here you can see what redirect bank is currently activated" | t }}
                </v-card-subtitle>
                <v-card-text v-if="activeCompanyBanks" class="asc-banks-list">
                    <div v-for="item in activeCompanyBanks" :key="item.swift">
                        <v-row class="align-center">
                            <v-col class="">
                                <img :alt="item.name + '_logo'" :src="assets_url + '/img/banks/' + item.swift + '.svg'"
                            /></v-col>
                            <v-col>
                                <v-col class="pb-0 subtitle-1">{{ "Swift" | t }}:</v-col>
                                <v-col class="pt-0 ">{{ item.swift ? item.swift : "-" }}</v-col>
                            </v-col>
                            <v-col>
                                <v-col class="pb-0 subtitle-1">{{ "Status" | t }}:</v-col>
                                <v-col class="pt-0">
                                    <span
                                        v-if="item.status"
                                        class="dot"
                                        :style="{ 'background-color': getStatusColor(item.status) }"
                                    />
                                    <span>{{ item.status ? item.status : "" }}</span>
                                </v-col>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions>
            <v-spacer />
            <v-btn color="black" text @click="handleEditClick">
                {{ "Edit" | t }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import settings from "@/settings";

export default {
    name: "redirect-banks-card",
    data() {
        return {
            assets_url: settings.assets_url
        };
    },
    async mounted() {
        await this.getAvailableBanks();
    },
    computed: {
        ...mapState(["activeCompanyBanks"])
    },
    methods: {
        ...mapActions(["getAvailableBanks"]),
        handleEditClick() {
            this.$router.push({ name: "redirect-banks-edit" });
        },
        getStatusColor(status) {
            if (status === "active") {
                return "#4CAF50";
            } else if (status === "pending") {
                return "#FB8C00";
            } else {
                return "#999999";
            }
        }
    }
};
</script>

<style scoped>
.asc-banks-list img {
    width: 140px;
    height: 54px;
    border-radius: 5px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.1);
}
.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
